<template>
  <div class="shop_head">
    <head-top></head-top>

    <div class="center_top width_center_1200" v-show="center_top">
      <div class="shop_logo float_left">
        <router-link to="/">
          <img src="/images/logo.png" alt="迅貓先鋒" />
        </router-link>
      </div>
      <div class="title float_left">{{ title }}</div>
      <div class="shop_top_seach float_right">
        <div class="search_input">
          <input
            v-model="keyword"
            type="text"
            :placeholder="config && config.searchhotkey"
            @keyup.enter="search"
          />
          <svg-icon iconClass="search" @click="search" />
        </div>
        <div v-if="config" class="keywords">
          <span
            v-for="(item, index) in config.searchhotkeylist.split(',')"
            :key="index"
            @click="handleSearchKey(item)"
          >{{ item }}</span>
        </div>
      </div>
    </div>
    <!-- nav -->
    <div v-if="nav_show" class="shop_top_nav">
      <div class="width_center_1200">
        <div
          class="shop_top_nav_left"
          :class="{ 'cur' : subnav_show }"
          @mouseover="subnav_show?subnav:subnav=true"
          @mouseleave="subnav_show?subnav:subnav=false"
        >
          {{ lang.categories }}
          <i class="el-icon-caret-bottom" />
          <transition name="el-zoom-in-top">
            <leftBar :change_color="change_color" v-show="subnav"></leftBar>
          </transition>
        </div>
        <div class="shop_top_nav_right">
          <ul>
            <li :class="{ 'cur': $route.path === '/home/coffee' }">
              <router-link to="/home/coffee?type=2">{{ lang.coffee }}</router-link>
            </li>
            <li :class="{ 'cur': $route.path === '/goods/list' }">
              <router-link to="/goods/list">{{ lang.hotsale }}</router-link>
            </li>
            <li :class="{ 'cur': $route.path === '/goods/seckill' }">
              <router-link to="/goods/seckill">{{ lang.special_offer }}</router-link>
            </li>
            <li :class="{ 'cur': $route.path === '/card/list' }">
              <router-link to="/card/list">{{ lang.card_buy }}</router-link>
            </li>
            <li :class="{ 'cur': $route.path === '/home/machine' }">
              <router-link to="/home/machine">{{ lang.machine_location }}</router-link>
            </li>
            <li :class="{ 'cur': $route.path === '/points/index' }">
              <router-link to="/points/index">{{ lang.points_mall }}</router-link>
            </li>
            <li :class="{ 'cur': $route.path === '/about_us' }">
              <router-link to="/about_us">{{ lang.about_us }}</router-link>
            </li>
            <li :class="{ 'cur': $route.path === '/contact_us' }">
              <router-link to="/contact_us">{{ lang.contact_us }}</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import leftBar from '@/components/LeftBar/index.vue'
import HeadTop from '@/components/ShopHead/Top.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    leftBar,
    HeadTop
  },
  props: {
    title: String,
    nav_show: Boolean,
    keyword: {
      type: String,
      default: undefined
    },
    subnav_show: {
      type: Boolean,
      default: false
    },
    change_color: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      subnav: true,
      cart_count: 0,
      center_top: true
    }
  },
  computed: {
    lang() {
      return this.$t('public_head')
    },
    ...mapGetters(['isLogin', 'cartNum', 'config'])
  },
  watch: {
    subnav_show(val) {
      this.subnav = val
    }
  },
  methods: {
    search() {
      if (this.$route.path !== '/goods/list') {
        this.$router.push(`/goods/list?keyword=${this.keyword}`)
      }
      this.$emit('search', this.keyword)
    },
    handleSearchKey(keyword) {
      if (this.$route.path !== '/goods/list') {
        this.$router.push(`/goods/list?keyword=${keyword}`)
      }
      this.$emit('search', keyword)
    }
  },
  created() {
    let _that = this
    this.subnav = this.subnav_show
    // 监听滚动条
    window.addEventListener(
      'scroll',
      () => {
        let topHeight = _that.nav_show ? 124 : 210
        var scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop
        if (scrollTop > topHeight) {
          this.center_top = false
        } else {
          this.center_top = true
        }
      },
      true
    )
  }
}
</script>

<style lang="scss" scoped>
.shop_head {
  z-index: 666;
  position: fixed;
  background: #fff;
  left: 0;
  right: 0;
  border-bottom: 1px solid #ec9221;
  .title {
    font-size: 24px;
    color: #4f4f4f;
    line-height: 124px;
    padding-left: 30px;
  }
}

.center_top:after {
  display: block;
  clear: both;
  content: '';
}

.shop_logo {
  margin: 28px 0;
  height: 68px;
  img {
    width: 182px;
    margin-top: 16px;
  }
}

.shop_top_nav {
  height: 40px;
  background: #ec9221;
  font-size: 14px;
  line-height: 40px;
  color: #fff;
  .shop_top_nav_left {
    text-align: center;
    float: left;
    width: 140px;
    // background: #d78722;
    box-sizing: border-box;
    position: relative;
    &.cur,
    &:hover {
      background: #d78722;
    }
    i {
      padding-left: 14px;
    }
  }
  .shop_top_nav_right {
    float: left;
    ul li {
      float: left;
      &.cur {
        background: #d78722;
      }
    }
    ul li a {
      line-height: 40px;
      width: 140px;
      text-align: center;
      color: #fff;
      display: block;
    }
    ul li a:hover {
      background: #d78722;
    }
  }
}

.shop_top_seach {
  margin-top: 36px;
  margin-left: 224px;
  .search_input {
    width: 377px;
    border: 1px solid #ec9221;
    box-sizing: border-box;
    font-size: 12px;
    display: flex;
    align-items: center;
    border-radius: 12px;
    padding: 3px 15px;
    input {
      width: 100%;
      height: 30px;
      outline: 0;
      border: 0;
      font-size: 14px;
      color: #4f4f4f;
    }
    .svg-icon {
      cursor: pointer;
    }
  }
  .keywords {
    padding-top: 4px;
    span {
      color: #aaaaaa;
      font-size: 12px;
      margin-left: 12px;
      cursor: pointer;
    }
  }
}
</style>